// ---
import React from "react";
import PropTypes from "prop-types";
import {connect} from "react-redux";
import {withRouter} from "react-router";
import {authActions, Icon, modal, NavIconText, PageContent, PageWrapper, ScrollableCard} from "@mc/mc-legacy";
import AppWrapper from "./AppWrapper";
import FileUploadApi from "../api/gen/qsign/FileUploadApi";
import {Col, DropdownItem, DropdownMenu, DropdownToggle, Row, UncontrolledDropdown} from "reactstrap";
import Header from "../components/Header";
import "./Layout.scss";
import {formValueSelector} from "redux-form";
import SearchField from "../components/SearchField";
import {OAplikaci} from "../components/OAplikaci";
import * as pozadavkyActions from "../actions/pozadavkyActions";
import {setUserLogout} from "../actions/logoutStatusActions";
import MobileTabContainer from "../components/MobileTabContainer";

/**
 *
 */

class CustomPageLayout extends React.Component {
    static propTypes = {
        appName: PropTypes.string,
        title: PropTypes.string,
        menu: PropTypes.object.isRequired,
        header: PropTypes.bool,
        headerButton: PropTypes.bool,
        searchUserField: PropTypes.bool,
        searchSignerField: PropTypes.bool,
        searchField: PropTypes.bool,
        searchPlaceholder: PropTypes.string,
        mobilHeader: PropTypes.string,
        content: PropTypes.object,
    };
    static defaultProps = {
        appName: "Podepisování dokumentů",
        headerButton: true,
        searchUserField: false,
        searchSignerField: false,
        searchField: true,
    };

    constructor(props) {
        super(props);
        this.state = {
            viewId: null,
        };
    }

    componentDidMount() {
    }

    componentWillUnmount() {
        const {files} = this.props;
        files && files.length > 0 && FileUploadApi.deleteDocuments(files.map((v) => v.uuid));
    }


    handleServis = () => {
        this.props.history.push("/administrace/sablony");
    };
    showOAplikaci = () => {
        this.props.dispatch(
            modal.ModalActions.show(OAplikaci, {}, "O aplikaci", {
                size: "md",
            })
        );
    };
        handleLogout = () => {
        this.props.dispatch(setUserLogout());
        this.props.dispatch({ type: 'LOGOUT' });
        this.props.dispatch(authActions.logout());
    };
    onChange = (value) => {
        this.props.dispatch(
            pozadavkyActions.filter({
                fulltext: value,
            })
        );
        this.props.history.push("/vyhledavani?q=" + value);
    };

    static formName = "customPageLayout";
    render() {
        const {
            appName,
            title,
            menu,
            headerButton,
            header,
            content,
            searchUserField,
            searchSignerField,
            searchField,
            searchPlaceholder,
            mobilHeader,
            filter,
            customHeaderButton,
            vlastniPodepsaniHeader,
            itemList,
        } = this.props;
        const fulltext = itemList && itemList.filter && itemList.filter.fulltext;
        let button;

        if (customHeaderButton) {
            button = customHeaderButton;
        }
        return (
            <AppWrapper homeLink={"/"} appName={appName}>
                <PageWrapper>
                    <PageContent
                        header={
                            header && (
                                <Header
                                    button={button}
                                    title={title}
                                    searchUserField={searchUserField}
                                    searchField={searchField}
                                    searchSignerField={searchSignerField}
                                    searchPlaceholder={searchPlaceholder}
                                    history={this.props.history}
                                />
                            )
                        }
                        leftPanel={menu}
                        leftPanelClassName={"customLeftPanel d-none d-md-block"}
                    >
                        <ScrollableCard detail className="scrollableContent" header={filter}>
                            <Row noGutters className="mb-3 d-flex d-md-none  justify-content-end">
                                <Col sm={10} xs={10} className="d-flex mobil-header align-items-end">
                                    {mobilHeader}
                                </Col>
                                <Col sm={1} xs={1} className={"text-right"}>
                                    <UncontrolledDropdown id="help">
                                        <DropdownToggle nav className="icon-text">
                                            <NavIconText icon={<Icon icon="question-circle"/>}/>
                                        </DropdownToggle>
                                        <DropdownMenu right>
                                            <DropdownItem href={`${serverContextPath}/napoveda`} target="blank">
                                                Nápověda
                                            </DropdownItem>
                                            <DropdownItem onClick={this.showOAplikaci}>O aplikaci</DropdownItem>
                                        </DropdownMenu>
                                    </UncontrolledDropdown>
                                </Col>
                                <Col sm={1} xs={1} className={"text-right"}>
                                    <UncontrolledDropdown id="user">
                                        <DropdownToggle nav className="icon-text">
                                            <NavIconText icon={<Icon icon="user"/>}/>
                                        </DropdownToggle>
                                        <DropdownMenu right>
                                            <DropdownItem onClick={this.handleLogout}>Odhlásit</DropdownItem>
                                        </DropdownMenu>
                                    </UncontrolledDropdown>
                                </Col>
                            </Row>
                            <Row>
                                <Col className="mb-3 d-md-none">
                                    <SearchField
                                        value={fulltext}
                                        onChange={(value) => this.onChange(value)}
                                        placeholder={searchPlaceholder || "Vyhledat v dokumentech"}
                                    />
                                </Col>
                            </Row>
                            <Row>
                                <Col className="d-md-none">
                                    <MobileTabContainer/>
                                </Col>
                            </Row>
                            {this.props.children}
                        </ScrollableCard>
                    </PageContent>
                </PageWrapper>
            </AppWrapper>
        );
    }
}

function mapStateToProps(state) {
    const selector = formValueSelector(CustomPageLayout.formName);
    return {
        files: selector(state, "files"),
    };
}

export default withRouter(connect(mapStateToProps)(CustomPageLayout));
